import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase/firebase";

// ============================================================
// GA4 EVENT HELPER
// ============================================================
//
// The project already initializes Firebase Analytics (src/firebase/firebase.js)
// but doesn't yet call logEvent() anywhere. This is a thin, safe wrapper
// around the existing `analytics` instance — it never creates a second
// analytics instance and never throws if analytics fails to initialize
// (e.g. blocked by an ad blocker, or running in an environment without
// `window`), so a tracking failure can never break the product.

export function trackEvent(eventName, params = {}) {
  try {
    if (!analytics) return;
    logEvent(analytics, eventName, params);
  } catch (err) {
    // Analytics should never be able to break the app.
    console.warn(`[analytics] failed to log "${eventName}":`, err);
  }
}
